// Mirrors Finkit.FAQ contracts (FaqCategoryAppService + FaqAppService).

export interface FaqDto {
  id: string;
  categoryId: string;
  question: string;
  answer: string;
}

export interface FaqCategoryDto {
  id: string;
  title: string;
}

// Returned by GetListWithFaqsAsync — the whole list rendered on the page.
export interface FaqCategoryViewModel {
  id: string;
  title: string;
  featureDisplayNames: string[];
  faqs: FaqDto[];
}

export interface CreateUpdateFaqCategoryDto {
  title: string;
}

export interface CreateFaqDto {
  categoryId: string;
  question: string;
  answer: string;
}

export interface UpdateFaqDto {
  question: string;
  answer: string;
}

export interface UpdateCategoryFeaturesDto {
  categoryId: string;
  features: string[];
}

export const MAX_QUESTION_LENGTH = 1024;
export const MAX_ANSWER_LENGTH = 8000;
export const MAX_CATEGORY_TITLE_LENGTH = 200;
